import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const JourneyHeader = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { id: "home", label: "Home", route: "/" },
    { id: "journey", label: "INSPIYAH JOURNEY", route: "/journey" },
    { id: "social", label: "Social", route: "/social" },
    { id: "donations", label: "Donations", route: "/donations" },
    { id: "referrals", label: "Referrals", route: "/referrals" },
    { id: "shop", label: "Shop", route: "/store" }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/90 backdrop-blur-sm shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <div 
            className="cursor-pointer group flex items-center space-x-3"
            onClick={() => navigate('/')}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_portfolio-ct/artifacts/3ginulsc_obey%203%20%2821%29.png"
              alt="YAH HEALTH WEALTH HAPPINESS Logo"
              className="w-16 h-16 object-contain group-hover:scale-110 transition-transform duration-300 drop-shadow-lg"
            />
            <div>
              <h1 className="text-xl font-bold bg-gradient-to-r from-brand-deep to-fire-main bg-clip-text text-transparent">
                INSPIYAH
              </h1>
              <p className="text-xs text-gray-500">Journey</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => navigate(item.route)}
                className={`relative text-sm font-normal tracking-wide transition-all duration-300 hover:-translate-y-0.5 ${
                  activeSection === item.id 
                    ? "text-brand-deep font-semibold" 
                    : "text-gray-600 hover:text-fire-main"
                }`}
              >
                <span>{item.label}</span>
                {activeSection === item.id && (
                  <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-brand-main to-fire-main" />
                )}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-black hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 py-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  navigate(item.route);
                  setIsMobileMenuOpen(false);
                }}
                className={`flex items-center justify-between w-full text-left px-4 py-3 text-sm font-normal tracking-wide transition-colors ${
                  activeSection === item.id
                    ? "text-black bg-gray-50 font-semibold" 
                    : "text-gray-600 hover:text-black hover:bg-gray-50"
                }`}
              >
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default JourneyHeader;
